<div class="cards-container col-lg-10 col-sm-12 col-md-12 p-5 d-flex flex-column justify-content-center mt-3">
  <div *ngIf="customTitle" customTitle="true" class="justify-content-center">
    <h2 class="title-page" >
        Criar conta
    </h2>
  </div>
  <span class="info-text justify-content-center">Selecione o perfil que melhor representa você ou sua empresa.</span>
  <div class="box-alert mt-2 mb-2">
    <i class="fas fa-info-circle"></i>
    <p>A garantia ordinária para pessoas físicas deve ser solicitada pelo aplicativo para celulares.</p>
  </div>
  <div class="row justify-content-center">
    <div class="col-12 col-md-6 col-lg-5 col-xl-4 d-flex justify-content-center">
      <div class="card custom-btn-hover" (click)="setForm(1)">
          <div class="icon">
            <span class="material-icons-outlined">
              person_outline
            </span>
          </div>
          <h2 class="text-center legend-card">Pessoa Física</h2>
          <p>Cadastro para investidores individuais de DPGE.</p>
          <span class="continuar">Continuar ></span>
      </div>
    </div>
    <div class="col-12 col-md-6 col-lg-5 col-xl-4 d-flex justify-content-center">
      <div class="card custom-btn-hover" (click)="setForm(2)">
          <div class="icon">
            <span class="material-icons-outlined">
              corporate_fare
            </span>
          </div>
          <h2 class="text-center legend-card">Pessoa Jurídica</h2>
          <p>Cadastro para empresas que investem.</p>
          <span class="continuar">Continuar ></span>
      </div>
    </div>
    <!-- <div class="col d-flex justify-content-center">
      <div class="card custom-btn-hover" (click)="setForm(3)">
          <div class="icon">
            <span class="material-icons-outlined">
              trending_up
            </span>
          </div>
          <h2 class="text-center legend-card">Fundo de Investimento</h2>
          <p>Cadastro para fundos registrados.</p>
          <span class="continuar">Continuar ></span>
      </div>
    </div> -->
    <!-- <div class="col d-flex justify-content-center">
      <div class="card custom-btn-hover" (click)="setType(2)">
          <div class="icon">
            <span class="material-icons-outlined">
              real_estate_agent
            </span>
          </div>
          <h2 class="text-center legend-card">Corretoras / Adm. Fundos / DTVM'S</h2>
          <p>Cadastro para instituições intermediárias.</p>
          <span class="continuar">Continuar ></span>
      </div>
    </div> -->
  </div>
  <!-- <div *ngIf="customTitle" class="form-row d-flex justify-content-center">
    <button class="duvida" (click)="openModalInfoPerfis()">
      Qual perfil escolher?
    </button>
  </div> -->
</div>
